import React from 'react';
import Currency from 'components/Currency/Currency';

const TableCurrency = ({ value, showCents }) => (
  <Currency amount={value || 0} showCents={showCents || false} />
);

export default TableCurrency;
